<!-- //
同Layout，只是去掉侧边菜单栏
@auth xuyd
@date 2022-11-27
//-->
<template>
  <div class="full-layout-container">
    <div class="layout-main">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {NavMenu} from './layout.js'
import {mapState} from 'vuex'
import adapter from './adapter'

export default {
  name: 'LayoutFull',
  components: {NavMenu},
  data() {
    return {}
  },
  mixins: [adapter],
  mounted: function () {
  },
  computed: {
    ...mapState({}),
  },
}
</script>

<style lang="less" scoped>
@import '../assets/css/variables.less';

.full-layout-container {
  width: 100%;
  height: calc(100vh);
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;

  .layout-nav {
    width: 100%;
    height: @topNavHeight !important;
    padding: 0 0 1px 0;
    margin: 0;
    //background: #FFFFFF;
    //border-bottom: 1px solid #efefef;
    box-sizing: border-box;
  }

  .layout-main {
    height: 100%;
    padding: 0;
    margin: 0;
    flex: 1;
  }
}

</style>
